  //-------------------------header-sticky-js-start--------------

$(window).scroll(function () {

  if ($(this).scrollTop() > 90) {

    $('header').addClass('sticky-header');

  } else {

    $('header').removeClass('sticky-header');

  }

});

//------------------------header-sticky-js-end------------------
  
  
  
  $(".testimonial-slider").owlCarousel({
    items: 1,
    loop: true,
    margin: 20,
    autoplay: true,
    nav: true,
    navText: ['<img src="https://cdn.shopify.com/s/files/1/0711/7848/5994/files/button_-_prev-slide.svg" />', '<img src="https://cdn.shopify.com/s/files/1/0711/7848/5994/files/button-next-slide.svg" />'],
    dots: true,
    center: true,
    responsive: {
      0: {
        items: 1,
        autoplay: true,
      },
      767: {
        items: 1,
        autoplay: true,
      },
      1024: {
        items: 2.3
      }
    }
  })


    $(".video-testimonial-slider").owlCarousel({
    items: 1,
    loop: true,
    margin: 20,
    autoplay: false,
    nav: true,
    navText: ['<img src="https://cdn.shopify.com/s/files/1/0711/7848/5994/files/button_-_prev-slide.svg" />', '<img src="https://cdn.shopify.com/s/files/1/0711/7848/5994/files/button-next-slide.svg" />'],
    dots: true,
    center: true,
    responsive: {
      0: {
        items: 1,
        autoplay: true,
      },
      767: {
        items: 1,
        autoplay: true,
      },
      1024: {
        items: 6.3
      }
    }
  })

  $(".alchemy-slider").owlCarousel({
    items: 1,
    loop: true,
    margin: 20,
    autoplay: false,
    nav: true,
    navText: ['<img src="https://cdn.shopify.com/s/files/1/0711/7848/5994/files/button_-_prev-slide.svg" />', '<img src="https://cdn.shopify.com/s/files/1/0711/7848/5994/files/button-next-slide.svg" />'],
    dots: true,
    responsive: {
      0: {
        items: 1,
        autoplay: true,
      },
      767: {
        items: 1,
        autoplay: true,
      },
      1024: {
        items: 2
      }
    }
  })



  
    $(document).ready(function () {

    // Close button click
    $('#close-btn').click(function () {

        // navbar-toggler / navbar_toggle trigger
        $('.navbar-toggler, .navbar_toggle').trigger('click');

    });

});








 $(document).ready(function () {

  // PLAY / PAUSE
  $('.play-btn').click(function () {

    let currentVideo = $(this).closest('.video-card').find('video')[0];

    // ✅ If SAME video is playing → pause it
    if (!currentVideo.paused) {
      currentVideo.pause();
      $(this).html('<img src="https://cdn.shopify.com/s/files/1/0711/7848/5994/files/play-button.png?v=1776241287">');
      return;
    }

    // ⛔ Pause all videos
    $('video').each(function () {
      this.pause();
    });

    // 🔁 Reset all buttons
    $('.play-btn').html('<img src="https://cdn.shopify.com/s/files/1/0711/7848/5994/files/play-button.png?v=1776241287">');

    // ▶ Play current video
    currentVideo.play();
    $(this).html('<img src="https://cdn.shopify.com/s/files/1/0711/7848/5994/files/pouse-btn.png">');

  });

  // MUTE / UNMUTE
  $('.mute-btn').click(function () {
    let video = $(this).closest('.video-card').find('video')[0];

    video.muted = !video.muted;

    if (video.muted) {
      $(this).html('<img src="https://cdn.shopify.com/s/files/1/0711/7848/5994/files/mute.png">');
    } else {
      $(this).html('<img src="https://cdn.shopify.com/s/files/1/0711/7848/5994/files/volume-high.png">');
    }
  });

});


function toggleCheck(label) {
      const box = label.querySelector('.custom-check');
      const inp = label.querySelector('input');
      inp.checked = !inp.checked;
      box.classList.toggle('checked', inp.checked);
    }
 
    function toggleSection() {
      const sec = document.getElementById('categorySection');
      const btn = document.getElementById('toggleBtn');
      const isHidden = sec.style.display === 'none';
      sec.style.display = isHidden ? 'flex' : 'none';
      btn.innerHTML = isHidden ? '<svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M0.700012 6.48996L6.20001 0.98996L11.7 6.48996" stroke="#193817" stroke-width="1.4" stroke-linecap="round"/></svg>' : '<svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.7 0.700012L6.20001 6.20001L0.700012 0.700012" stroke="#193817" stroke-width="1.4" stroke-linecap="round"/></svg>';
    }
    function updateRange() {
      const minR = document.getElementById('minRange');
      const maxR = document.getElementById('maxRange');
      let minVal = parseInt(minR.value);
      let maxVal = parseInt(maxR.value);
 
      if (minVal > maxVal) {
        const temp = minVal;
        minVal = maxVal;
        maxVal = temp;
        minR.value = minVal;
        maxR.value = maxVal;
      }
 
      document.getElementById('minLabel').textContent = '$' + minVal;
      document.getElementById('maxLabel').textContent = '$' + maxVal;
 
      const pMin = (minVal / 500) * 100;
      const pMax = (maxVal / 500) * 100;
      const fill = document.getElementById('rangeFill');
      fill.style.left = pMin + '%';
      fill.style.width = (pMax - pMin) + '%';
    }
 
    function applyFilterold() {
      const min = document.getElementById('minRange').value;
      const max = document.getElementById('maxRange').value;
      const cats = [...document.querySelectorAll('.checkbox-item input:checked')]
        .map(i => i.closest('.checkbox-item').querySelector('.label-text').textContent);
 
      const msg = cats.length
        ? `Applied: ${cats.join(', ')} | $${min}–$${max}`
        : `Applied: No categories | $${min}–$${max}`;
 
      showToast(msg);
    }
 
    function clearFilter() {
      document.querySelectorAll('.checkbox-item').forEach(item => {
        item.querySelector('input').checked = false;
        item.querySelector('.custom-check').classList.remove('checked');
      });
      document.getElementById('minRange').value = 0;
      document.getElementById('maxRange').value = 500;
      updateRange();
      showToast('Filters cleared');
    }
 
    function showToast(msg) {
      const toast = document.getElementById('toast');
      toast.textContent = msg;
      toast.classList.add('show');
      setTimeout(() => toast.classList.remove('show'), 2800);
    }
 
    updateRange();
    

    

